import { defineStore } from 'pinia';
import api from '@/services/api';
import { getParamsUrl } from './forma_utils';

export const useFormaStore = defineStore('formaStore', {
  state: () => ({
    entity: 'forma',
    formaList: [],
    page: 1,
    filters: {},
  }),
  actions: {
    async findAllFormaHTTP(params) {
      const result = await api.get(
        `/${this.entity}?${getParamsUrl({ page: +this.page, ...this.filters, ...params })}`,
      );
      if (result && result.data) {
        this.formaList.splice(0, this.formaList.length, ...result.data);
        this.setPage(this.page + 1);
        return true;
      }
      return false;
    },

    async firstForma() {
      this.setPage(1);
      this.emptyList();
      await this.findAllFormaHTTP();
    },
    setPage(page) {
      this.page = page;
    },
    emptyList() {
      this.formaList = [];
    },
    setFilters(filters) {
      this.filters = filters;
    },
    resetFilters() {
      this.filters = {};
    },
  },
});
